document.addEventListener('DOMContentLoaded', () => {

  const dropdownMenus = document.querySelectorAll('.has-dropdown');

  dropdownMenus.forEach( el => {
    const contactMenuButtons = el.getElementsByClassName('navbar-link')
    for (let contactMenuButton of contactMenuButtons) {
      contactMenuButton.addEventListener('click', () => {
        el.classList.toggle('is-active');
      });
    }
  });

});
